import { Box, Container } from '@mui/material';
import { useUserAccess } from '../../hooks/useRole';
import Error from '../elements/Error';
import Loader from '../elements/Loader';
import DashboardProjects from './DashboardProjects';

const HomeContent = () => {
  const {error, isError, isLoading, isExecutiveManager } = useUserAccess();

  if (isLoading) return <Loader />;

  return (
    <Container maxWidth="xl" className="mb-4 mt-3">
      {isError && (
        <Error>
          <h2>{error}</h2>
          <p className="text-center">
            Unable to fetch data. Please contact your administrator to resolve
            this issue.
          </p>
        </Error>
      )}
      <Box>
        <DashboardProjects isExecutiveManager={isExecutiveManager} />
      </Box>
    </Container>
  );
};

export default HomeContent;
